import RestClient from './rest-client'

export default class Overweight extends RestClient {
  static get url () {
    return this.apiUrl + '/overweights'
  }

  static get paramKey () {
    return 'overweight'
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }

  get amount () {
    const shipment = this.shipment
    if (shipment) {
      const rate = shipment.rate
      if (rate) {
        const service = rate.service
        if (service) {
          return Number(this.overweight) * Number(service.extra_kg_overweight_price)
        }
      }
    }
    return 0
  }

  get userEmail () {
    if (this.shipment.user) {
      return this.shipment.user.email
    }

    return ''
  }

  async apply () {
    const { data } = await this.constructor._put(this.constructor.apiUrl + `/overweights/${this.id}/deduction`)

    return data
  }

  async rebate () {
    const { data } = await this.constructor._put(this.constructor.apiUrl + `/overweights/${this.id}/rebate`)

    return data
  }

  async refund () {
    const { data } = await this.constructor._put(this.constructor.apiUrl + `/overweights/${this.id}/refund`)

    return data
  }

  async cancelRebate () {
    const { data } = await this.constructor._put(this.constructor.apiUrl + `/overweights/${this.id}/cancel_rebate`)

    return data
  }

  async updateEvidence (formData) {
    const { data } = await this.constructor._put(this.constructor.apiUrl + `/overweights/${this.id}`, formData)
    return data
  }
}
